export const environment = {
    production: true,
    apiUrl: 'https://supplieraccess-api.vizientinc.com',
    oktaIssuer: 'https://login.alliancewebs.net/oauth2/ausmkot3jmgtQXrtZ0x7',
    oktaClientId: '0oa12inirqoU5TV8R0x8',
    oktaRedirectUri: 'https://supplieraccess.vizientinc.com/login/callback',
    ssoReturnUrl: 'https://supplieraccess.vizientinc.com',
    ssoCookieManagerUrl: 'https://sso.alliancewebs.net/SsoCookieManager.axd',
    bidManagementBaseUrl: 'https://bidmanagement.vizientinc.com',
    supplierProfileBaseUrl: 'https://supplierprofile.vizientinc.com',
    bidManagementURL: 'https://bidmanagement.vizientinc.com',
    splitKey: 'nurtsnsj564j9imml1ajp746q4hb3fd80a2g',
    registrationRedirectUrl: 'https://apps.vizientinc.com/UserRegistration/site/vz/SupplierRegistration.html#/001-VZ'
};
